import { useQuery } from '@tanstack/react-query'
import { ExtendableQueryOptions } from 'shared/api/api.types'

import { containerApi } from '../..'
import {
  DownloadableApp,
  GetDownloadableAppResponse,
  GetDownloadableAppsResponse
} from './getDownloadableApps.types'

export const getDownloadableApps = async () => {
  const response =
    await containerApi.get<GetDownloadableAppsResponse>('/downloadable-apps')
  return response.data.data
}

export const GET_DOWNLOADABLE_APPS_QUERY_KEY = 'getDownloadableApps'

export const useGetDownloadableAppsQuery = (
  options?: ExtendableQueryOptions<DownloadableApp[]>
) => {
  return useQuery({
    queryKey: [GET_DOWNLOADABLE_APPS_QUERY_KEY],
    queryFn: getDownloadableApps,
    ...options
  })
}

export const getDownloadableApp = async (appId: string) => {
  const response = await containerApi.get<GetDownloadableAppResponse>(
    `/downloadable-apps/${appId}`
  )
  return response.data.data
}

export const GET_DOWNLOADABLE_APP_QUERY_KEY = 'getDownloadableApp'

export const useGetDownloadableAppQuery = (
  appId: string | undefined,
  options?: ExtendableQueryOptions<DownloadableApp>
) => {
  return useQuery({
    queryKey: [GET_DOWNLOADABLE_APP_QUERY_KEY, appId],
    queryFn: () => getDownloadableApp(appId!),
    enabled: !!appId,
    staleTime: 60_000,
    ...options
  })
}
